import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { STREAMERS_QUERY } from 'embroil/gql/queries/streamers';
import { service } from '@ember/service';

export default class Streamers extends Route {
  @service head;

  async model({ game_slug }) {
    try {
      this.data = useQuery(this, () => [
        STREAMERS_QUERY,
        { variables: { gameSlug: game_slug } },
      ]);

      await this.data.promise;
      return {
        streamers: this.data.data.streamers.items,
        gameSlug: game_slug,
      };
    } catch (error) {
      console.error('Error loading streamers:', error);
      // Return empty streamers list as fallback
      return {
        streamers: [],
        gameSlug: game_slug,
      };
    }
  }

  afterModel(model) {
    if (model) {
      this.head.updateMeta({
        title: `Streamers for ${model.gameSlug}`,
        description: `Watch live streamers playing ${model.gameSlug}`,
        ogTitle: `Streamers for ${model.gameSlug}`,
        ogDescription: `Watch live streamers playing ${model.gameSlug}`,
        canonical: `https://1vX.gg/game/${model.gameSlug}/streamers`
      });
    }
  }
}
